import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'
import type { AdminMetersDataType } from './../model/types'
import type { MeterTypesSelectType } from '@/entities/Meters'
import { useLoadMeters } from './../model/api'
import { useTranslate } from '@/shared/lib'

export const useModelTable = defineStore('cabinet_admin_meter_table', () => {
  const { trs } = useTranslate()

  const meters = ref<AdminMetersDataType[]>([])
  const meterTypes = ref<MeterTypesSelectType[]>([])

  /**
   * Настройки шапки формы
   */
  const headers = [
    {
      title: '№',
      key: 'order_number',
      value: ({ order_number }) => order_number + 1,
      sortable: false,
    },
    {
      title: trs('itf.meter_type'),
      key: 'meter_type_id',
      value: ({ meter_type_id }) =>
        meterTypes.value.find((item) => item.id == meter_type_id)?.meter_name || trs('itf.not_set'),
      sortable: false,
    },
    {
      title: trs('itf.serial_number'),
      key: 'serial_number',
      sortable: false,
    },
    {
      title: trs('itf.address'),
      key: 'rs_address',
      value: ({ rs_address }) => rs_address || trs('itf.not_set'),
      sortable: false,
    },
    { title: trs('itf.tariff_count_label'), key: 'tariff_count', sortable: false },
    { title: trs('itf.ktt'), key: 'ktt', sortable: false },
    { title: trs('itf.control'), key: 'action', sortable: false },
  ]

  const loadTable = () => {
    const result = useLoadMeters()

    watchEffect(() => {
      if (result.data.value) {
        meters.value = [...(result.data.value.data.meters || [])].sort(
          (a, b) => a.order_number - b.order_number,
        )

        meterTypes.value = result.data.value.payload.meter_types
      }
    })
  }

  return {
    meters,
    meterTypes,
    headers,

    loadTable,
  }
})
